import { ArrowDownward, ArrowUpward } from '@material-ui/icons'
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { FlexHorizontal, Spacer } from '@vestaboard/installables'

import { Alert } from '@material-ui/lab'
import { Link } from '../link'
import React from 'react'
import { SearchInput } from '../../ui/SearchInput'
import { useListTopSearchTerms } from '../../api/useListTopSearchTerms'

const RESULTS_PER_PAGE = 100

export const TrendingSearchTerms = () => {
  const [terms, setTerms] = React.useState('')
  const [reverse, setReverse] = React.useState(true)
  const { data, loading, error, fetchMore } = useListTopSearchTerms({
    input: {
      limit: RESULTS_PER_PAGE,
      cursor: null,
      terms,
      reverse
    }
  })

  if (loading) {
    return <CircularProgress />
  }

  if (error) {
    return <Alert severity='error'>{error.message}</Alert>
  }

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          right: 24,
          top: 100
        }}>
        <SearchInput value={terms} onSearch={terms => setTerms(terms.toLocaleLowerCase())} />
      </Box>
      <Spacer size='large' />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography>Search Term</Typography>
              </TableCell>
              <TableCell
                onClick={() => setReverse(reverse => !reverse)}
                style={{
                  width: 200,
                  cursor: 'pointer'
                }}>
                <FlexHorizontal>
                  <Typography>Times Searched</Typography>
                  {reverse ? (
                    <ArrowDownward
                      style={{
                        fontSize: 18
                      }}
                    />
                  ) : (
                    <ArrowUpward
                      style={{
                        fontSize: 18
                      }}
                    />
                  )}
                </FlexHorizontal>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data?.listTopSearchTermsV2?.searchTermAnalytics || [])
              .sort((a, b) =>
                reverse
                  ? a.count > b.count
                    ? -1
                    : a.count < b.count
                    ? 1
                    : 0
                  : a.count < b.count
                  ? -1
                  : a.count > b.count
                  ? 1
                  : 0
              )
              .map(search => (
                <TableRow key={search.term}>
                  <TableCell>
                    <Typography variant='h6'>
                      <Link to={`/search-terms/term/${search.term}`}>{search.term}</Link>
                    </Typography>
                  </TableCell>
                  <TableCell>{search.count}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {data?.listTopSearchTermsV2?.nextCursor ? (
        <Box paddingTop='1rem' display='flex' justifyContent='center'>
          <Button
            variant='outlined'
            onClick={async () => {
              if (!data?.listTopSearchTermsV2?.nextCursor) {
                return
              }

              await fetchMore({
                variables: {
                  input: {
                    limit: RESULTS_PER_PAGE,
                    cursor: data?.listTopSearchTermsV2?.nextCursor
                  }
                },
                updateQuery: (prev, { fetchMoreResult }) => {
                  if (!fetchMoreResult) {
                    return prev
                  }
                  return {
                    listTopSearchTermsV2: {
                      __typename: prev.listTopSearchTermsV2.__typename,
                      searchTermAnalytics: [
                        ...prev.listTopSearchTermsV2.searchTermAnalytics,
                        ...fetchMoreResult.listTopSearchTermsV2.searchTermAnalytics
                      ],
                      nextCursor: fetchMoreResult.listTopSearchTermsV2.nextCursor
                    }
                  }
                }
              })
            }}>
            Load More
          </Button>
        </Box>
      ) : null}
    </>
  )
}
